import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import {MsalService} from "@azure/msal-angular";
import { Cliente } from '../../../models/Cliente';
import { Persona } from 'src/app/hojas-call-center/models/Persona';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class PersonesService
{
  private hostPeticionClientes:string = environment.clientesWSBase;
  constructor(private http: HttpClient,private msalService:MsalService){}

  //recoge la info de la cia seleccionada en la seccion de Taller y CIA
  public getDatosDni(token:string,dni:string):Promise<Persona[]>
  {
    let url:string = this.hostPeticionClientes + "/Persones"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
    {
      parameters:
      [
        [
          {
            campo:"nif",
            operacion:"=",
            valor:dni.toUpperCase()
          }
        ],
      ],
      select:["nom","direcc","telef","nif","email"],
      orden:[["nom","asc"]]
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(response)
        {
          resolve(response);
        },
        error(err)
        {
          reject(err);
        },
      });
    });
  }

  public getValoresClientes(token:string,arrParams:Object):Promise<Cliente[]>
  {
    let url:string = this.hostPeticionClientes + "/Clientes"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(response)
        {
          resolve(response);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      });
    });
  }

}
